webpackJsonp([4],{

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_Auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_UriUtils__ = __webpack_require__(4);




var googleLogoutPromise = new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__auth_Auth__["a" /* default */].loadGoogleAuthApi(function (error) {
        if (error) return reject(error);

        window.gapi.auth2.getAuthInstance().signOut().then(resolve).catch(reject);
    });
});

var facebookLogoutPromise = new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__auth_Auth__["a" /* default */].loadFacebookAuthApi(function (error) {
        if (error) return reject(error);

        window.FB.getLoginStatus(function (loginResponse) {
            if (loginResponse.status === "connected") {
                window.FB.logout(resolve);
            } else {
                resolve();
            }
        }, true); // true : will not cache FB requests
    });
});

// Try to logout from Facebook and Google
Promise.all([googleLogoutPromise, facebookLogoutPromise]).catch(function (e) {
    console.error("An error occurred while login out from Facebook/Google : ", e);
}).finally(function () {
    // Redirect to SSO (which will determine final redirect page)
    var maybeRedirect = new __WEBPACK_IMPORTED_MODULE_2__utils_UriUtils__["a" /* default */](window.location.search).getQueryParam("redirectUri");

    window.location.replace(__WEBPACK_IMPORTED_MODULE_0__api_Api__["a" /* AuthApi */].logoutAllUri(maybeRedirect));
});

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__ = __webpack_require__(4);


// TODO RCH : refactor by using sp-react-commons (first, we need to support passing headers like 'X-Requested-With' for each request)

var AuthApi = {
    logoutAllUri: function logoutAllUri(maybeRedirect) {
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/logoutAll").addQueryParam("redirectUri", maybeRedirect).build();
    },
    loginUri: "/login",
    oauthLoginUri: function oauthLoginUri(maybeLang) {
        var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/sso/v" + apiVersion + "/login").addQueryParam("maybeLang", maybeLang).build();
    },
    socialLoginUri: function socialLoginUri(socialId) {
        var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return "/sociallogin?apiVersion=" + apiVersion + "&socialId=" + socialId;
    },
    oauthSocialLoginUri: function oauthSocialLoginUri(socialId, maybeLang) {
        var apiVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/sso/v" + apiVersion + "/sociallogin?socialId=" + socialId).addQueryParam("maybeLang", maybeLang).build();
    }
};

var UserApi = {
    baseUrl: "/user/api/users",
    checkEmail: function checkEmail(email) {
        return $.ajax({
            type: 'GET',
            url: this.baseUrl + "/checkEmail?email=" + email,
            contentType: 'application/json',
            dataType: 'json'
        });
    }
};



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UriUtils; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UriUtils = function () {
    function UriUtils(url) {
        _classCallCheck(this, UriUtils);

        this.url = url;
    }

    _createClass(UriUtils, [{
        key: 'addQueryParam',
        value: function addQueryParam(paramKey, paramValue) {
            if (paramValue) {
                if (this.url.indexOf("?") > -1) {
                    this.url += '&' + paramKey + '=' + paramValue;
                } else {
                    this.url += '?' + paramKey + '=' + paramValue;
                }
            }

            return this;
        }
    }, {
        key: 'getQueryParam',
        value: function getQueryParam(param) {
            // Seems to be the best way to extract a query parameter from url
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            var results = regex.exec(this.url);

            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    }, {
        key: 'build',
        value: function build() {
            return this.url;
        }
    }]);

    return UriUtils;
}();



/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    googleClientId: "1025537527851-gg2rrp3dm013vo6u5t1ck179sumtdspv.apps.googleusercontent.com",
    facebookAppId: "262131947223648",
    facebookApiVersion: "2.11",
    facebookPermissions: "public_profile,email"
});

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AppConfig__ = __webpack_require__(5);


var Auth = {
    loadGoogleAuthApi: function loadGoogleAuthApi() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        // First, add meta needed for Google Auth API
        var googleClientId = document.createElement("meta");
        googleClientId.name = "google-signin-client_id";
        googleClientId.content = __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].googleClientId;
        document.head.appendChild(googleClientId);

        // Then, dynamically load Google API
        // Attach a callback function that will be called when the library will be loaded
        window.onLoadGoogleAuthApi = function () {
            window.gapi.load('auth2', function () {
                window.gapi.auth2.init().then(callback);
            });
        };
        var googleApiScript = document.createElement("script");
        googleApiScript.src = "https://apis.google.com/js/platform.js?onload=onLoadGoogleAuthApi";
        googleApiScript.setAttribute('defer', '');
        googleApiScript.setAttribute('async', '');
        // Catch any exception while loading google script (Firefox private navigation mode is blocking this script)
        googleApiScript.onerror = function (error) {
            callback(error);
        };
        document.head.appendChild(googleApiScript);
    },
    loadFacebookAuthApi: function loadFacebookAuthApi() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        // Will be asynchronously called when Facebook SDK will be loaded
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].facebookAppId,
                cookie: true,
                xfbml: true,
                version: "v" + __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].facebookApiVersion
            });

            callback();
        };

        // Load Facebook SDK
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            // Catch any exception while loading facebook script (Firefox private navigation mode is blocking this script)
            js.onerror = function (error) {
                callback(error);
            };
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ })

},[272]);


// WEBPACK FOOTER //
// javascripts/logoutPage.js